import styled, {css} from 'styled-components';
import { getThemeColor, getThemeFont } from './Theme';
import { LinkHandler } from '../components/common/Link';
import {
  BREAKPOINT_LG, BREAKPOINT_MD,
  FONT_STANDARD,
  FONT_HEADLINES,
} from './General';

export const FontStyleHelveticaMedium = css`
  font-family: ${FONT_STANDARD};
  font-weight: 500;
`;

export const FontStyleHelveticaBold = css`
  font-family: ${FONT_STANDARD};
  font-weight: 700;
`;

export const FontStyleMomentumRegular = css`
  font-family: ${FONT_HEADLINES};
  font-weight: 400;
`;

export const FontStyleMomentumBold = css`
  font-family: ${FONT_HEADLINES};
  font-weight: 700;
`;

export const TextBase = css`
  font-family: ${getThemeFont('default')};
  font-size: 1rem;
  line-height: 1.45;
`;

export const TextBaseBold = css`
  ${FontStyleHelveticaBold};
  font-size: 1rem;
  line-height: 1.45;
`;

export const HeadlineBase = css`
  font-family: ${getThemeFont('defaultHeadline')};
  font-weight: 700;
  //hyphens: auto;
  word-wrap: break-word;
`;

export const HeadlineBaseRegular = css`
  font-family: ${getThemeFont('defaultHeadline')};
  font-weight: 400;
  //hyphens: auto;
  word-wrap: break-word;
`;

export const TextHeadlineBase = css`
  ${TextBase};
  //hyphens: auto;
  word-wrap: break-word;
`;

export const TextHeadlineBold = css`
  ${TextBaseBold};
  //hyphens: auto;
  word-wrap: break-word;
`;

export const TEXTS = {
  small: css`
    ${TextBase};
    font-size: .875rem;
    line-height: 1.4;
  `,
  headline1: css`
    ${HeadlineBase};
    font-size: 1.75rem;
    line-height: 1.25;
    
    ${BREAKPOINT_LG} {
      font-size: 2.5rem;
    }
  `,
  headline2: css`
    ${HeadlineBase};
    font-size: .875rem;
    line-height: 1.3;
    
    ${BREAKPOINT_LG} {
      font-size: 1.375rem;
    }
  `,
  headline3: css`
    ${HeadlineBase};
    font-size: 1.5rem;
    line-height: 1.3;
  `,
  headline4: css`
    ${TextHeadlineBold};
    font-size: 1.375rem;
    line-height: 1.2;
  `,

  headline5: css`
    ${TextHeadlineBold};
    font-size: 1.125rem;
    line-height: 1.2;
  `,
}

export const PageTitle = styled.h1`
  ${TEXTS.headline1};
`;

export const PageTitleAsH2 = styled.h1`
  ${TEXTS.headline2};
` ;

export const SubTitle = styled.h2`
  ${TEXTS.headline4};
  ${HeadlineBase};
  margin-bottom: 1rem;
  text-transform: none;
`;

export const SubPageTitle = styled.h2`
  ${TEXTS.headline2};
  margin-bottom: 1rem;
`;

export const StrongBig = styled.strong`
  ${TEXTS.headline5};
`;

export const TextDefault = styled.p`
  ${TextBase};
`;

export const TextLink = styled(LinkHandler)`
  ${TextBase};
  pointer-events: auto;
  text-decoration: underline;
  color: ${getThemeColor('purple')};
  transition: color .15s ease-out;

  :hover {
    color: ${getThemeColor('pink')};
  }
`;

export const TextInfo = styled.p`
  ${TEXTS.small};
  color: ${getThemeColor('darkGray')};
`;

export const TextInput = styled.input`
  ${TextBase};
`;

export const TextBlock = styled.p`
  line-height: 1.4;
  margin-bottom: 2rem;
`;

export const UlStyled = styled.ul`
  ${TextBase};
  list-style: none;
  
  li {
    display: flex;
    font-size: 1.125rem;

    :not(:last-child) {
      margin-bottom: .125rem;
    }
    
    &:before {
      display: block;
      content: '';
      width: .75rem;
      height: .75rem;
      margin-right: .75rem;
      background: url(${`${process.env.PUBLIC_URL}/images/checkmark_alt.svg`}) no-repeat center center;
      margin-top: .4375rem;
    }
  }
`;
